export default __webpack_public_path__ + "static/media/home_pic1.79f67e77.png";